import { appConfig } from '#/shared/config/AppConfig';

import { MaterialIcon } from './MaterialIcon';

export const ErrorCard = ({
  title = 'Sorry, something went wrong.',
  description = "We couldn't load this page, please try again later.",
  supportEmail = appConfig.feedback.email,
  showIcon = false,
}: {
  title?: string;
  description?: string;
  supportEmail?: string;
  showIcon?: boolean;
}) => {
  return (
    <div className="items-center justify-center bg-gray-100">
      <div className="max-w-[448px] items-center text-center">
        {showIcon && <MaterialIcon iconName="warning" size={'lg'} className="text-error" />}
        <h1 className="text-24 text-gray-900 font-700">{title}</h1>
        <p className="text-on-surface pt-sm">{description}</p>
        <p className="text-grey-800 pt-lg">
          For support, contact:{' '}
          <a href={`mailto:${supportEmail}`} className="text-blue-600 hover:underline">
            {supportEmail}
          </a>
        </p>
      </div>
    </div>
  );
};
